<template>
<div class="chapter">
<div class="inner_page">
<div id="copy">
<p class="Copyright">© 2024 Clay Hernandez</p>
<p class="Copyright">All rights reserved. No part of this book may be used or reproduced in any manner without written permission except in the case of brief quotations embodied in critical articles or reviews.</p>
<p class="Copyright">This is a work of fiction. Any similarity to real persons, living or dead, is coincidental and not intended by the author.</p>
<p class="Copyright"><span class="Italics _idGenCharOverride-1">Renegade Immortality</span></p>
<p class="Copyright">Brown Books Publishing Group</p>
<p class="Copyright0">Dallas, TX/New York, NY</p>
<p class="Copyright0"><a href="http://www.BrownBooks.com" target="_blank">www.BrownBooks.com</a></p>
<p class="Copyright0">(972) 381-0009</p>
<p class="Copyright">A New Era in Publishing®</p>
<p class="Copyright">Publisher’s Cataloging-In-Publication Data</p>
<p class="Copyright">Names: Clay, Christopher, 1985- author.</p>
<p class="Copyright0">Title: Renegade immortality / Christopher Clay.</p>
<p class="Copyright0">Description: Dallas, TX ; New York, NY : Brown Books Publishing Group, [2024]</p>
<p class="Copyright0">Identifiers: ISBN: 978-1-61254-665-0 | LCCN: 2023949761</p>
<p class="Copyright0 ParaOverride-1">Subjects: LCSH: Special operations (Military science)--Fiction. | Grief--Fiction. | Siblings--Fiction. | Kidnapping--Fiction. | Research--Peru--Fiction. | LCGFT: Action and adventure fiction. Thrillers (Fiction) | BISAC: FICTION / Action &amp; Adventure. | FICTION / Thrillers / Military. | FICTION / Magical Realism.</p>
<p class="Copyright0">Classification: LCC: PS3603.L3864 R46 2024 | DDC: 813/.6--dc23</p>
<p class="Copyright">eISBN 978-1-61254-666-7</p>
<p class="Copyright0">LCCN 2023949761</p>
<p class="Copyright">Printed in the United States</p>
<p class="Copyright0">10 9 8 7 6 5 4 3 2 1</p>
<p class="Copyright">For more information or to contact the author, please go to <a href="http://www.ChristopherClayAuthor.com" target="_blank">www.ChristopherClayAuthor.com</a>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03copy.vue?17b58b7c